import React, { Component } from 'react'
import { Link, withRouter } from "react-router-dom"
import { Container, Row, Col, Button, Card, Navbar, Nav, NavDropdown, Image, Table } from 'react-bootstrap'
import ErrorExamAnalysisHOme from '../components/exams/error_exam_analysis/ErrorExamAnalysisHome';


import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from 'lodash.flowright';
import PreloaderTwo from '../components/preloader/PreloaderTwo'
import BrandLogo from '../components/navbars/BrandLogo'



const FETCH_SESSION_DATA = gql`
  query(
          $mobile: String!, $exam_session_id: ID) {
            getStudentExamSessions(mobile: $mobile, exam_session_id: $exam_session_id){
                in_time
                less_time
                over_time
                total_questions
              subject_report{
                id
                subject
                in_time
                less_time
                over_time
                totalSubjectWiseMarks
               }

              result_questions{
                id
                subject
                status
                reason_for_wrong
                comments
              }
          }
      }
`;

const STUDENT_GLOBALS = gql`
  query($mobile: String!) {
            studentGlobals(mobile: $mobile){
                errorReasons{
                    id
                    reason
                }
              
          }
      }
`;



class ExamWiseErrorAnalysis extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }


    render() {

        if (Cookies.get("studenttoken") == undefined)
            this.props.history.push("/student/login");
        const getStudentExamSessions = this.props.getStudentExamSessions;
        const loading1 = getStudentExamSessions.loading;
        const error1 = getStudentExamSessions.error;
        if (error1 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }

        const studentGlobals = this.props.studentGlobals;
        const loading2 = studentGlobals.loading;
        const error2 = studentGlobals.error;
        if (error2 !== undefined) {
            alert("Server Error. " + error2.message);
            return null;
        }

        return (
            <div className='practice_exams_area'>
                <Navbar bg="white" className="header-top">
                    <Container>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        <Navbar.Collapse id="basic-navbar-nav">
                            <Navbar.Brand as={Link} to="/student/home" className="mr-auto" inline="true">
                                <BrandLogo />
                            </Navbar.Brand>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
                <Container>
                    <Row className="align-items-center my-3">
                        <Col className="d-flex justify-content-between align-center">
                            <div className="title-block">
                                <h5 className="title mb-0">Error Analysis</h5>
                            </div>
                            <div className="right-content d-flex align-items-center">
                                <button className="d-flex align-items-center rounded-pill btn px-3 py-2 ml-2" style={{ background: '#212b64', color: '#fff', border: '1px solid #212b64' }} onClick={this.props.history.goBack} > Back</button>
                            </div>
                        </Col>
                    </Row>
                </Container>
                <Container>
                    {(loading1 == true || loading2 == true) && (<PreloaderTwo />)}
                    {
                        !loading1 && !loading2 && (
                            <ErrorExamAnalysisHOme getStudentExamSessions={getStudentExamSessions.getStudentExamSessions} studentGlobals={studentGlobals.studentGlobals} />
                        )
                    }
                </Container>
            </div>
        )
    }
};


export default
    withRouter(
        compose(graphql(FETCH_SESSION_DATA,
            {
                options: props => ({
                    variables: {
                        mobile: Cookies.get("mobile"),
                        exam_session_id: parseInt((props.history.location.state || {}).sessionid),

                    },
                    fetchPolicy: "network-only"
                }), name: "getStudentExamSessions"
            }), graphql(STUDENT_GLOBALS,
                {
                    options: props => ({
                        variables: {
                            mobile: Cookies.get("mobile"),
                        }
                        ,
                        fetchPolicy: "network-only"
                    }), name: "studentGlobals"
                }),

        )(ExamWiseErrorAnalysis));
